module.exports = __webpack_public_path__ + "assets/grab-arrow-left.ab284196.svg";